


export const typePartner: any  = [ '全て','あ','か','さ','た','な','は','ま','や','ら','わ' ];
